import React from 'react';
import { Button, Glyphicon } from 'react-bootstrap'
import { withRouter } from 'react-router-dom';
import { Form, TextBox } from 'fw/forms'

class Search extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.initialState();
    }

    initialState = () => {
        return {
            form: {
                text: ""
            }
        }
    }
    
    handleChange = (form) => {
        this.setState({ form });
    }

    handleSearch = () => {
        this.props.history.push('/search?p=' + this.state.form.text);
    }

    render() {
        return (
            <Form
                className="sidebar-form"
                onSubmit={this.handleSearch}
                onChange={this.handleChange}
                values={this.state.form}>
                <div className="input-group">
                    <TextBox name="text" placeholder="Global search..." />
                    <span className="input-group-btn">
                        <Button id="btnGlobalSearch" type="submit" bsStyle="default" className="pull-right" style={{ borderRadius: "0px" }}><Glyphicon glyph="search" /></Button>
                    </span>
                </div>
            </Form>)
    }
}

export default withRouter(Search);



// WEBPACK FOOTER //
// ./src/layouts/main/sidebar/Search.js